module.exports = __webpack_public_path__ + "static/media/52803643_2452964194778757_1748098577629970432_o.afff5cd6.jpg";